import {
  onLoadErrorEvent
} from './common';

export const orderPreferenceRetrieveError = onLoadErrorEvent('order preferences retrieve error');

export const orderPreferenceUpdateError = onLoadErrorEvent('order preferences update error');
